export class WebStorageAccessor {
  private cache: { rawValue: string; parsedData: unknown } | null = null;

  constructor(
    public webStorageRef: Storage,
    protected key: string,
  ) {}

  stringify(data: unknown) {
    const serialized = JSON.stringify(data);
    this.webStorageRef.setItem(this.key, serialized);
    this.cache = { rawValue: serialized, parsedData: data };
  }

  clearSelectively(persistItems: string[]) {
    const persistItemsSet = new Set(persistItems);
    const keys = Object.keys(this.webStorageRef);
    keys.forEach((key) => {
      if (persistItemsSet.has(key)) return;
      this.webStorageRef.removeItem(key);
    });
  }

  parse<T>(): T | null {
    const rawValue = this.webStorageRef.getItem(this.key);

    if (!rawValue || rawValue === 'undefined') {
      this.cache = null;
      return null;
    }

    if (this.cache && this.cache.rawValue === rawValue) {
      return this.cache.parsedData as T;
    }

    const parsedData = JSON.parse(rawValue);
    this.cache = { rawValue, parsedData };

    return parsedData;
  }
}
